import { editCell } from '@mummssoftware/utils/constants';
import { getFormDisplayName } from '@mummssoftware/utils/utils';
import { EditCellRenderer, CreatedByCell } from './CellRenderer';

// Custom value getter to display form name with supplemental title when present
const formDisplayNameValueGetter = ({ data }: { data?: mumms.GenericForm }) => {
  if (!data) {
    return '';
  }
  return getFormDisplayName({
    displayname: data.displayname || data.formname || '',
    supplementaltitle: data.supplementaltitle,
  });
};

export const smallColumnTableDefs = [
  {
    headerName: 'Last Name',
    field: 'patientlastname',
    cellClass: 'no-border',
    suppressMenu: true,
    width: 100,
  },
  {
    headerName: 'First Name',
    field: 'patientfirstname',
    cellClass: 'no-border',
    suppressMenu: true,
    width: 100,
  },
  {
    headerName: 'Form',
    field: 'formname',
    cellClass: 'no-border',
    suppressMenu: true,
    valueGetter: formDisplayNameValueGetter,
  },
];
export const expandedColumnTableDefs = [
  {
    headerName: 'Patient ID',
    field: 'patientnumber',
    cellClass: 'no-border',
    sortable: true,
    filter: true,
    width: 110,
  },
  {
    headerName: 'Last Name',
    field: 'patientlastname',
    cellClass: 'no-border',
    sortable: true,
    filter: true,
    width: 120,
  },
  {
    headerName: 'First Name',
    field: 'patientfirstname',
    cellClass: 'no-border',
    sortable: true,
    filter: true,
    width: 120,
  },
  {
    headerName: 'Form',
    field: 'formname',
    cellClass: 'no-border',
    sortable: true,
    filter: true,
    valueGetter: formDisplayNameValueGetter,
  },
  {
    headerName: 'Last Edit',
    field: 'modifieddate',
    cellClass: 'no-border',
    sortable: true,
    filter: true,
    width: 115,
  },
  {
    headerName: 'Visit Date',
    field: 'visitdate',
    cellClass: 'no-border',
    sortable: true,
    filter: true,
    width: 115,
  },
  {
    headerName: 'Created By',
    field: 'createpersonfirstname',
    cellClass: 'no-border',
    sortable: true,
    filter: true,
    cellRendererFramework: CreatedByCell,
    width: 160,
  },
  {
    headerName: '',
    field: editCell,
    cellClass: 'no-border no-pad',
    suppressMenu: true,
    cellRendererFramework: EditCellRenderer,
    width: 33,
  },
];
